import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { LoggerService } from 'src/app/ax-commons-logger/logger/logger.service';
import { AxUiService } from 'src/app/services/ax-ui.service';
import { WorkEventInvitation, WorkEventInvitationsService } from '../../../_generated/work-rest-api';

@Component({
  selector: 'app-event-checkin-modal',
  templateUrl: './event-checkin-modal.page.html',
  styleUrls: ['./event-checkin-modal.page.scss'],
})
export class EventCheckinModalPage {
  @Input() invitation: WorkEventInvitation;
  @Input() accessKey: string;

  public checkInLoading = false;
  public checkInSuccessful = false;

  constructor(
    private modalController: ModalController,
    private axEventInvitationsService: WorkEventInvitationsService,
    private axUiService: AxUiService,
  ) {
  }

  get isAlreadyCheckedIn(): boolean {
    return !!this.invitation?.checkInAt;
  }

  get persons(): number {
    return this.invitation?.numberOfPersons ?? 1;
  }

  get checkInTime(): string {
    if (!this.invitation?.checkInAt) {
      return '';
    }
    return new Date(this.invitation.checkInAt).toLocaleTimeString('de-CH', { hour: '2-digit', minute: '2-digit' });
  }

  public async checkIn(): Promise<void> {
    this.checkInLoading = true;
    try {
      await this.axEventInvitationsService.eventInvitationsV1ControllerCheckIn({ accessKey: this.accessKey }).toPromise();
      this.checkInSuccessful = true;
      this.invitation = { ...this.invitation, checkInAt: new Date().toISOString() as any };
    } catch (checkInException) {
      LoggerService.ERROR(this, 'checkInException', checkInException);
      this.axUiService.showError('Check-In fehlgeschlagen.').then();
    }
    this.checkInLoading = false;
  }

  public close(): void {
    this.modalController.getTop().then(instance => instance?.dismiss({ checkInSuccessful: this.checkInSuccessful }));
  }
}
